module.exports = __webpack_public_path__ + "img/wz-8-4-4.dc86e76c.jpg";